module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item hidden-mobile nav-loader"
  }, [_c('div', {
    style: ({
      display: _vm.display
    })
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-fw"
  }), _vm._v(" "), (_vm.isDebug) ? _c('span', [_vm._v(_vm._s(_vm.lastRunningTaskText))]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5b76254"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Templates/TopBar/Navigation/LiLoader.vue
// module id = 719
// module chunks = 1